import { AssetRow } from '@/components/AssetRow';
import { EtfFlowsCard } from '@/components/EtfFlowsCard';
import { CorporateBTCMonitor } from '@/components/CorporateBTCMonitor';
import { StablecoinsCard } from '@/components/StablecoinsCard';
import { Badge } from '@/components/ui/badge';
import { Activity, TrendingUp, Building2, Coins } from 'lucide-react';

const MarketMonitor = () => {
  return (
    <div className="space-y-8 p-4 md:p-6">
      {/* Hero Section */}
      <div className="space-y-3 fade-in-up">
        <div className="flex items-center gap-4 flex-wrap">
          <h1 className="text-4xl font-bold tracking-tight text-gradient">
            Market Monitor
          </h1>
          <Badge className="text-sm px-3 py-1 bg-primary/10 text-primary border-primary/20">
            <Activity className="h-3 w-3 mr-1" />
            2 Ativos Monitorados
          </Badge>
        </div>
        <p className="text-muted-foreground text-lg max-w-2xl">
          Monitoramento em tempo real de métricas de mercado, derivativos e smart money
        </p>
        <div className="gradient-line w-24 mt-2" />
      </div>

      {/* Asset Rows - Estilo Coinglass */}
      <div className="space-y-4">
        <div className="fade-in-up delay-100">
          <AssetRow asset="BTC" />
        </div>
        <div className="fade-in-up delay-200">
          <AssetRow asset="ETH" />
        </div>
      </div>

      {/* ETF Flows & Stablecoins Section */}
      <div className="fade-in-up delay-300">
        <div className="mb-4">
          <div className="flex items-center gap-2 mb-1">
            <TrendingUp className="h-5 w-5 text-primary" />
            <h2 className="text-xl font-semibold">ETF Flows</h2>
          </div>
          <p className="text-sm text-muted-foreground">
            Fluxos de entrada e saída de ETFs institucionais
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <EtfFlowsCard asset="BTC" />
          <EtfFlowsCard asset="ETH" />
          <StablecoinsCard />
        </div>
      </div>

      {/* Corporate BTC Monitor Section */}
      <div className="fade-in-up delay-400">
        <div className="mb-4">
          <div className="flex items-center gap-2 mb-1">
            <Building2 className="h-5 w-5 text-primary" />
            <h2 className="text-xl font-semibold">Corporate BTC</h2>
          </div>
          <p className="text-sm text-muted-foreground">
            SEC Filings e Holdings Institucionais de empresas crypto
          </p>
        </div>
        <CorporateBTCMonitor />
      </div>
    </div>
  );
};

export default MarketMonitor;
